import axios from "axios";
import store from '@/store'
import localStorage from '@/utils/userToken'
import { API_BASE_URL, getApiUrl } from '@/config/api'

let refreshPromise = null;

const logout = () => {
  store.commit('user/removeUserInfo')
  store.commit('user/setIsLogin', true)
}

const refreshToken = () => {
  const token = localStorage.getToken();
  if (!token || !token.refresh_token) {
    return Promise.reject(new Error('Missing refresh token'));
  }

  if (!refreshPromise) {
    refreshPromise = axios({
      url: getApiUrl('/v1/login/refresh'),
      method: 'get',
      headers: { 'Authorization': `Bearer ${token.refresh_token}` }
    }).then(({ data: res }) => {
      if (res.status == 1) {
        const latestToken = localStorage.getToken() || token;
        localStorage.setToken({ ...latestToken, ...res.data })
        return res.data;
      }

      return Promise.reject(res);
    }).finally(() => {
      refreshPromise = null;
    })
  }

  return refreshPromise;
}

// 创建实例ce
const service = axios.create({
  // 请求域名
  baseURL: API_BASE_URL,
  // 设置超时时间
  timeout: 1000 * 50,
  // 请求头
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getToken();
    if (token && token.access_token) {
      config.headers['Authorization'] = `Bearer ${token.access_token}`;
    }

    if (config.url && !/^https?:\/\//i.test(config.url) && !config.url.startsWith('/')) {
      config.url = `/${config.url}`;
    }

    return config;
  },
  error => {

    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  //成功
  (response) => {
    if (response.status === 200) { //根据后端定义响应状态进行相应的处理,例：1数据返回成功，2未登录
      return response.data
    }
  },
  async (error) => {
    const originalRequest = error.config || {};

    if (error.response && error.response.status == 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        await refreshToken();
        return service(originalRequest);
      } catch (e) {
        console.log(e, 'error')
        logout();
      }
    }

    return Promise.reject(error);
  }
)

export default service
